// extracted by mini-css-extract-plugin
module.exports = {"pageGallery":"page-module--pageGallery--WNu8r","galleryImage":"page-module--galleryImage--1W-28"};